export { default } from './MyFinishedTasksList';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyFinishedTasksList/index.js